import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Style from 'assets/jss/material-dashboard-pro-react/views/profileStyle.jsx';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';

import Button from 'components/CustomButtons/Button.jsx';
import ProfilePicUpload from 'components/CustomUpload/FileUpload';

const Transition = (props) => {
  return <Slide direction='down' {...props} />;
};

export const UpdateProfilePhotoModal = ({
  user,
  open,
  close,
  classes,
  onError,
  onSuccess,
  profilePhoto,
  currentAvatar,
}) => (
  <Dialog
    classes={{
      root: classes.modalRoot,
      paper: classes.modal + ' ' + classes.modalSmall,
    }}
    open={open}
    TransitionComponent={Transition}
    keepMounted
    onClose={close}
    aria-labelledby='shipment-modal-slide-title'
    aria-describedby='shipment-modal-slide-description'
  >
    <DialogContent
      style={{
        backgroundColor: '#FFFFFF',
        margin: '0px 20px 0px 20px',
        borderRadius: '10px',
      }}
      id='shipment-modal-slide-description'
      className={classes.modalBody}
    >
      {/* FORM */}
      <ProfilePicUpload
        onError={onError}
        onSuccess={onSuccess}
        currentPic={profilePhoto}
        currentAvatar={currentAvatar}
        uid={user.uid}
      />
      <div
        style={{
          textAlign: 'center',
        }}
      >
        <Button
          className={classes.ltrButtonWhite}
          style={{ backgroundColor: '#6672e5' }}
          key='close'
          aria-label='Close'
          onClick={close}
        >
          CANCEL
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);

UpdateProfilePhotoModal.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(Style)(UpdateProfilePhotoModal);
